import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

const LandingHeading = ({ blok }) => {
  // console.log(blok)
  return (
    <div {...storyblokEditable(blok)} style={{ 
      backgroundColor: `${blok.bgColor?.color}`,
      marginTop: `${blok.marginTop}px`, marginBottom: `${blok.marginBottom}px`, color: `${blok.textColor?.color}` }} >
      <div className="container max-w-screen-2xl mx-auto px-3 py-10 text-center"
        style={{ paddingTop: `${blok.paddingTop}px`, paddingBottom: `${blok.paddingBottom}px` }} {...storyblokEditable(blok)}>
        <h1 className="text-4xl font-bold font-serif">{blok.heading}</h1>
        <p className="px-2 pt-5">{blok.subHeading}</p>
      </div>
    </div >
  )
}

export default LandingHeading
